import { scrollToId, CONTACTS } from "./data";

export default function Footer() {
  return (
    <footer className="bg-moss text-[#F9F6F0] pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-[#F9F6F0]/10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-4">
              <span className="w-14 h-14 rounded-full overflow-hidden bg-cream border border-[#F9F6F0]/20 shadow-lg shrink-0">
                <img
                  src="/logo-emblem.png"
                  alt="Luviae Aesthetics emblem"
                  className="w-full h-full object-cover"
                />
              </span>
              <p className="font-serif text-4xl font-light tracking-tight">
                Luviae <span className="italic text-gold">Aesthetics</span>
              </p>
            </div>
            <p className="mt-4 text-sm text-[#F9F6F0]/50 max-w-sm leading-relaxed">
              Honest aesthetics. Naturally radiant skin. Advanced skin
              treatments in a calm Mississauga sanctuary.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-5">
              Explore
            </p>
            <ul className="space-y-3 text-sm text-[#F9F6F0]/60">
              {[
                ["Philosophy", "philosophy"],
                ["Treatments", "treatments"],
                ["Results", "results"],
                ["Stories", "testimonials"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToId(id)}
                    className="hover:text-gold transition-colors duration-300"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-5">
              Reach us
            </p>
            <ul className="space-y-3 text-sm text-[#F9F6F0]/60">
              <li>{CONTACTS.phone}</li>
              <li>{CONTACTS.email}</li>
              <li className="leading-relaxed">{CONTACTS.address}</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#F9F6F0]/40">
          <p>© 2026 Luviae Aesthetics. All rights reserved.</p>
          <p data-testid="footer-domain">{CONTACTS.domain}</p>
        </div>
      </div>
    </footer>
  );
}
